export default "__VITE_ASSET__ofwY7BwX__"